import { render, staticRenderFns } from "./DecksView.vue?vue&type=template&id=11642aa9&scoped=true&"
import script from "./DecksView.vue?vue&type=script&lang=js&"
export * from "./DecksView.vue?vue&type=script&lang=js&"
import style0 from "./DecksView.vue?vue&type=style&index=0&id=11642aa9&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11642aa9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
